import { useContext } from 'react';
import { createContext } from 'react';

import { ProductSpecificationProps } from '../@types/ProductSpecificationProps';

export const ProductSpecificationContext = createContext<ProductSpecificationProps>({} as ProductSpecificationProps);

ProductSpecificationContext.displayName = 'ProductSpecification';

const ProductSpecificationProvider = (props: ProductSpecificationProps) => (
	<ProductSpecificationContext.Provider value={props}>{props.children}</ProductSpecificationContext.Provider>
);

export const useProductSpecification = () => {
	const context = useContext(ProductSpecificationContext);

	return context;
};

export default ProductSpecificationProvider;
